import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import fetcher from '@lib/fetcher'

export const IMAGE_IMPORT_EVENT = 'nfca:event-group-image-import'

const parse = (value, fallback) => (typeof value === 'string' && value !== '' ? JSON.parse(value) : (value || fallback))

// The group form's "Import images from an event" picker. Searches events
// with an image and writes the chosen one to
// event_group[adopt_image_from_event_id]; the group copies its original and
// crops when it saves. Tells the Sessions panel so it stops offering images.
const EventGroupImageImport = ({ initialEvent, eventsUrl }) => {
  const [selected, setSelected] = useState(parse(initialEvent, null))
  const [query, setQuery] = useState('')

  const { data: results } = useSWR(
    query.length >= 2 ? `${eventsUrl}?search=${encodeURIComponent(query)}` : null,
    fetcher
  )
  const withImages = (results || []).filter(event => event.image_url)

  useEffect(() => {
    window.dispatchEvent(new CustomEvent(IMAGE_IMPORT_EVENT, { detail: selected }))
  }, [selected])

  const choose = (event) => {
    setSelected(event)
    setQuery('')
  }

  if (selected) {
    return (
      <div className='flex items-center gap-4'>
        <input type='hidden' name='event_group[adopt_image_from_event_id]' value={selected.id} />
        {selected.image_url && <img src={selected.image_url} alt='' className='w-24 aspect-[4/3] object-cover rounded' />}
        <p className='flex-1 text-sm text-green-700 dark:text-green-300'>
          Images from <strong>{selected.name}</strong> will be copied to this group when you save.
        </p>
        <button
          type='button'
          onClick={() => setSelected(null)}
          className='shrink-0 px-3 py-1.5 rounded-md text-sm font-medium bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100'
        >
          Choose another
        </button>
      </div>
    )
  }

  return (
    <div>
      <label htmlFor='event-group-image-import-search' className='text-sm font-medium text-gray-700 dark:text-gray-300'>Find an event</label>
      <input
        id='event-group-image-import-search'
        type='search'
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder='Search events with an image…'
        className='mt-1 block w-full px-3 py-2 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm'
      />
      {results && (
        <ul className='divide-y divide-gray-200 dark:divide-gray-700'>
          {withImages.map(event => (
            <li key={event.id} className='flex items-center gap-3 py-2'>
              <img src={event.image_url} alt='' className='w-16 aspect-[4/3] shrink-0 rounded object-cover' />
              <p className='flex-1 min-w-0 text-sm font-medium text-gray-900 dark:text-white truncate'>{event.name}</p>
              <button
                type='button'
                onClick={() => choose(event)}
                className='shrink-0 px-3 py-1 rounded-md text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white'
              >
                Use these images
              </button>
            </li>
          ))}
          {withImages.length === 0 && (
            <li className='py-2 text-sm text-gray-500 dark:text-gray-400'>No matching events with an image.</li>
          )}
        </ul>
      )}
    </div>
  )
}

export default EventGroupImageImport
